module.exports = __webpack_public_path__ + "static/media/tesla.33bd2f75.jpg";